export default "__VITE_ASSET__BnE1TzPb__"